class LocalStorageKeys {
  static adminToken = "ghkjhfdkivhgrowihgiot-ioyrfiyity-oihguyuuiguyyuutytyty";
}
export default LocalStorageKeys;
